module.exports = __webpack_public_path__ + "img/square-share-nodes.ec57e52c.svg";